export class frameVideo {
    constructor(params) {
      //合并指定配置到默认配置,
      this.opts = Object.assign(
        {
          fromAnimate: [], //入场序列
          cycleAnimate: [], //循环序列
          toAnimate: [], //出场序列

         fromCallback:function(){},
         progress:function(){},
         callback:function(){},
  
          canvas: document.createElement("canvas"),
          w: 300,
          h: 300,
  
          seed: 4,
        },
        params
      );
      this.opts.canvas.width = this.opts.w;
      this.opts.canvas.height = this.opts.h;
      this._ctx = this.opts.canvas.getContext("2d");
  
      this.state = 0; //目前序列
      this.isPlay = 0; //是否播放
      this.isReverse = 0; //是否循环翻转
    }
    play() {
      let that = this;
        
      this.frame = 0;
      let number = 0;
      this.isPlay = 1;
      function loop() {
        let { w, h, fromAnimate, cycleAnimate, toAnimate, seed } = that.opts;
        let arr = [fromAnimate, cycleAnimate, toAnimate];

        if(that.state == 0 || that.state == 2){
          seed = 3;
        }else{
          seed = 4;
        }
  
        //是否已经加载完成
        if (arr[that.state].length) {
          if (number === seed) {
            // if (that.state >= 2) {
            //     frame = 0;
            // }
            // if(that.opts.id == 'page2_3'){
            //   console.log(that.frame,arr[that.state].length - 1,that.opts.canvas);
            // }
            if (arr[that.state].length - 1 < that.frame) {
              // console.log(that.state, "播放完成",that.opts.canvas);
              if(that.state == 0){
                that.opts.fromCallback();
              }
  
              if (that.state != 1) {
                if (that.state == 2) {
                    that._ctx.clearRect(0, 0, w, h);
                    that.clearFrame();
                    that.opts.callback();
                    return;
                }
                that.isReverse = 0;
                that.state++;
                that.frame = 0;
                
              } else {
                // that.isReverse = 1;
                // that.frame = arr[that.state].length - 1;
                that.frame = 0;
              }
              // that.isReverse = that.state == 1 ? 1 : 0;
            } else if(that.frame === 0 && that.state === 1){
                that.isReverse = 0;
            }
          
            
            // console.log(arr[that.state]);

  
            if (arr[that.state].length) {
              that._ctx.clearRect(0, 0, w, h);

              that._ctx.drawImage(arr[that.state][that.frame], 0, 0, w, h);

              number = 0;
  
              // that.isReverse ? that.frame-- : that.frame++;
              that.frame++
            }
          }
          number++;
        }

        that.opts.progress && that.opts.progress();
        that.timer = requestAnimationFrame(loop);
      }
      loop();
    }
    clearFrame() {
      this.state = 0; //目前序列
      this.frame = 0; //序列
      this.isPlay = 0; //是否播放
      this.isReverse = 0; //是否循环翻转
      cancelAnimationFrame(this.timer);
    }
  }
  export const imgLoad = async (arr) => {
    return new Promise((resolve) => {
      let preload = new createjs.LoadQueue(false);
      preload.setMaxConnections(5);
      preload.loadManifest(arr);
      preload.addEventListener("complete", (e) => {
        preload.isLoad = true;
        resolve(preload);
      });
    });
  };